exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".swiper-container[data-v-3cf21d34]{height:100vh;width:100%;text-align:center}.slide-img[data-v-3cf21d34]{width:100%;height:auto}.topleftdiv[data-v-3cf21d34]{left:1em}.topleftdiv[data-v-3cf21d34],.toprightdiv[data-v-3cf21d34]{top:1em;position:absolute;font-family:Aktiv Grotesk Corp,sans-serif;font-size:small;color:#000;z-index:9999}.toprightdiv[data-v-3cf21d34]{right:1em;text-align:right}.bottomcenterdiv[data-v-3cf21d34]{bottom:4em;position:relative;font-family:Aktiv Grotesk Corp,sans-serif;font-size:small;color:#000;z-index:9999}.swiper-button-prev[data-v-3cf21d34]{background-image:none;left:0;width:50vw;height:80vh;top:14vh}.swiper-button-next[data-v-3cf21d34]{background-image:none;right:0;width:50vw;height:80vh;top:14vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-3cf21d34&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Main.vue
// module id = 954
// module chunks = 0